import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import { Button, Checkbox, ControlLabel } from "react-bootstrap";
import InputMask from "react-input-mask";
import Alert from 'react-s-alert';
import * as Yup from "yup";
import FormikDatetime from '../Shared/FormikDateTime';
import FormikFormControl from '../Shared/Forms/FormikFormControl';
import LeadsService from '../utils/LeadsService';





class EditForm extends Component {
  state = { addDueDate: this.props.lead.due_at }
  render() {
    const validationSchema = Yup.object().shape({
      first_name: Yup.string()
        .max(30, "maximum 30 characters")
        .required("is required"),
      email: Yup.string()
        .max(100, "maximum 100 characters")
        .email("doesn't look like a valid email address")
        .required("is required"),
      mobile: Yup.string()
        .matches(/04\d\d \d\d\d \d\d\d/, "must be an Australian mobile number")
        .required("is required"),
      student_first_name: Yup.string()
        .max(50, "maximum 50 characters")
        .required("is required"),
      due_at: Yup.date().when('first_name', {
        is: (val) => this.state.addDueDate,
        then: Yup.date().required('please provide a reason'),
        otherwise: Yup.date().notRequired()
      }),
    });

    const { lead, onCancelSubmit } = this.props

    return (
      <div>
        {lead ? (
          <div>
            <Formik
              initialValues={{
                email: lead.email || "",
                first_name: lead.first_name || "",
                mobile: lead.mobile || "",
                student_first_name: lead.student_first_name || "",
                due_at: lead.due_at || moment().add(3, 'days').hours(8).startOf('hour').toDate()
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(true);
                const { onSubmit, lead } = this.props

                if (!this.state.addDueDate) values.due_at = null
                LeadsService.update(lead.id, values).then(data => {
                  Alert.success('Completed')
                  onSubmit(data)
                  setSubmitting(false);
                });
              }}
              render={({
                errors,
                touched,
                isSubmitting,
                values,
                setFieldValue,
                setFieldTouched, isValid
              }) => (
                <Form>
                  <div className={`form-group ${errors.email && touched.email && "has-error"}`} >
                    <ControlLabel>Email</ControlLabel>
                    <Field type="text" name="email" className="form-control" />
                    <ErrorMessage name="email" component="span" className="help-block" />
                  </div>

                  <div className={`form-group ${errors.first_name && touched.first_name && "has-error"}`} >
                    <ControlLabel>First Name</ControlLabel>
                    <Field type="text" name="first_name" className="form-control" />
                    <ErrorMessage name="first_name" component="span" className="help-block" />
                  </div>

                  <div className={`form-group ${errors.mobile && touched.mobile && "has-error"}`} >
                    <ControlLabel>Mobile</ControlLabel>
                    <Field type="text" name="mobile" className="form-control"
                    render={({ field }) => {
                      return (
                        <InputMask
                          mask="0499 999 999"
                          {...field}
                          className="form-control"
                          placeholder="Mobile number"
                        />
                      );
                    }}
                    />
                    <ErrorMessage name="mobile" component="span" className="help-block" />
                  </div>

                  <div className={`form-group ${errors.student_first_name && touched.student_first_name && "has-error"}`} >
                    <ControlLabel>Student First Name</ControlLabel>
                    <Field type="text" name="student_first_name" className="form-control" />
                    <ErrorMessage name="student_first_name" component="span" className="help-block" />
                  </div>


                  <Checkbox checked={this.state.addDueDate} onChange={() => { this.setState({ addDueDate: !this.state.addDueDate }) }}>
                    Add a Due Date?
                  </Checkbox>

                  {this.state.addDueDate && <FormikFormControl fieldName='due_at' errors={errors} touched={touched}>
                    <ControlLabel>When</ControlLabel>
                    <FormikDatetime
                      field="due_at"
                      input={{
                        value: moment(values.due_at).format("DD MMM YYYY h:mma"),
                        onChange: setFieldValue,
                        onBlur: setFieldTouched
                      }}
                      closeOnSelect={true}
                      dateFormat="DD MMM YYYY"
                      timeFormat="h:mma"
                    />
                  </FormikFormControl>}

                  <div style={{ marginTop: "20px" }}>
                    {onCancelSubmit && <Button onClick={onCancelSubmit} bsSize='small'>Whoops, cancel this</Button>}
                    <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='info' bsSize='small'>Go ahead and Update</Button>
                  </div>
                </Form>
              )}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}
export default EditForm;
